import React, { useState } from "react";
import "./Restaurants.css";

export default function CreateRestaurantForm({ onRestaurantCreated }) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleCreate = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const token = localStorage.getItem("access_token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/restaurants`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ name }),
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Errore creazione ristorante");
      }
      const newRestaurant = await res.json();
      onRestaurantCreated(newRestaurant);
      setName("");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <form className="create-restaurant-form" onSubmit={handleCreate}>
      {error && <p className="error-text">{error}</p>}
      <input
        type="text"
        placeholder="Nome ristorante"
        value={name}
        onChange={(e) => setName(e.target.value)}
        required
        className="restaurant-input"
      />
      <button type="submit" className="create-btn">Crea</button>
    </form>
  );
}
